import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=16bbf3fd&scoped=true&"
import script from "./ColorSwatch.vue?vue&type=script&setup=true&lang=js&"
export * from "./ColorSwatch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=16bbf3fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bbf3fd",
  null
  
)

export default component.exports